<script>

  import axios from 'axios'
  import defaultLayout from '../components/shared/layouts/default-layout.vue'
  import cleave from 'vue-cleave'
  import { isISBN } from '@/helpers/isbn.js'

  export default {
    name: 'NewScene',
    props: {

    },
    data () {
      return {
        // searchQuery: '',
        // ean13: null,
        isLoading: false,
        livreEan13: null,
        hasSucceeded: false,
        cleavOpts: {
          numericOnly: true,
          blocks: [13],
        },
      }
    },
    components: {
      cleave,
      layout: defaultLayout,
    },
    methods: {
      async findSuggestion (ean13) {
        if (!isISBN(ean13)) return
        this.isLoading = true
        this.hasSucceeded = false
        try {
          await axios.get(`/api/v2/ia/suggestions/${ean13}`)
        } catch (e) {
          throw e
        } finally {
          this.isLoading = false
          this.hasSucceeded = true
        }
      },
      searchSuggestion () {
        this.findSuggestion(this.livreEan13)
      },
    },

  }
</script>

<template lang="pug">

layout
  div.accueil-scene
    .columns.is-vcentered
      .column.is-4.is-offset-4
        form.box(@submit.prevent="searchSuggestion")
          h1.title.is-3 Ajouter un titre absent
          hr
          label(class="label") ISBN
          p.control
            cleave(:options="cleavOpts", @input="hasSucceeded = false", class="input", type="texte", v-model="livreEan13", placeholder="Entrer un numero isbn",  :disabled="isLoading")
          p.control(v-show="hasSucceeded")
            span Ce titre a été rajouté. Il sera disponible sous peu.
          p.control
            button(type="submit", class="button", :class="{'is-loading': isLoading}", :disabled="hasSucceeded") Ajouter
</template>

<style lang="postcss" scoped>



  .accueil-scene {
    // margin: 0 auto;
    // // max-width: 70%;
    // // padding-top: 40px;
    // padding-bottom: 200px;
    // font-family: $font-primary;
    // background-color: #ed174c;
    & .suggestionplaceholder {
      // width: 80px;
      // height: 80px;
      background-color: white;
      color: black;
      height: 100%;
      // display: inline-block;
    }
    & .bookrating {
      // height: 100%;
      height: 350px;
    }
    & .wrapper {
      text-align: center;
      // width: 80%;
      margin: 0 auto;
    }
    & .bigtitle {
      font-size: 80px;
    }
    & .title {
      color: black;
    }
    & .box {
      text-align: left;
    }

  }

</style>



// WEBPACK FOOTER //
// new-ean-scene.vue?4af8f7a0